/*
 * navbar-panel.js — GrapesNavbar (NavbarWidget) mobile panel anchoring.
 *
 * The dropdown panel is `position: fixed; left:0; right:0; bottom:0` so it spans the
 * whole screen even when the navbar itself is reduced to its hamburger icon inside a
 * flex header (logo outside the navbar). CSS alone cannot know where the bar ends,
 * so this writes the bar's bottom edge into `--pb-navbar-panel-top` on the <nav>
 * whenever a panel opens and on resize (see NavbarCss.Build in Palladium.PageBuilder).
 *
 * Everything else (open/close, scroll lock via :has, hamburger → X) stays pure CSS.
 * Event-delegated: works for navbars rendered later by Blazor. Esc closes open panels.
 * The editor canvas does the same in orchard-plugin.js (this file is not loaded there).
 */
(function () {
  if (window.__pdNavbarPanel) return;
  window.__pdNavbarPanel = true;

  function sync(nav) {
    if (!nav) return;
    var r = nav.getBoundingClientRect();
    nav.style.setProperty('--pb-navbar-panel-top', Math.max(0, Math.round(r.bottom)) + 'px');
  }

  function navOf(el) {
    return el && el.closest ? el.closest('.pb-navbar') : null;
  }

  function openNavs() {
    var out = [];
    document.querySelectorAll('.pb-navbar > .pb-menu-toggle:checked').forEach(function (cb) {
      out.push(cb.parentElement);
    });
    return out;
  }

  // Before the checkbox flips (label click) so the first paint already has the edge.
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.pb-navbar-toggler')) sync(navOf(t));
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('pb-menu-toggle')) sync(navOf(t));
  }, true);

  window.addEventListener('resize', function () { openNavs().forEach(sync); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    openNavs().forEach(function (nav) {
      var cb = nav.querySelector(':scope > .pb-menu-toggle');
      if (cb) cb.checked = false;
    });
  });
})();
